// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./$.iobject'),
    defined = require('./$.defined');

module.exports = function (it) {
  return IObject(defined(it));
};